import { pino } from 'pino';

export const logger = pino({
  level: process.env.WB_LOG_LEVEL || (process.env.WB_SILENT ? 'error' : 'trace'),
  transport: {
    target: 'pino-pretty',
    options: {
      colorize: process.env.NODE_ENV !== 'production',
      translateTime: true,
      ignore: 'pid,hostname',
    },
  },
});

export function serializeFormData(formData: FormData): Record<string, unknown> {
  return Object.fromEntries(formData.entries());
}
